module.exports = __webpack_public_path__ + "img/liucheng2.2c6c4323.png";